import ch from '../assets/images/flags/China.png'
import en from '../assets/images/flags/United States.png'
const options = [{
    value: 'cn',
    label: '中文简体',
    flag: ch
}, {
    value: 'en',
    label: 'English',
    flag: en
}]

export default options



// WEBPACK FOOTER //
// ./src/config/support.langs.js